import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';
import Utils from '../../../utils';
import { confirmPlanAcceptance as showPlanAcceptanceConfirm, getPlanDisplayName } from '../../../plan-acceptance';
import { requiresSalesContact } from '../../../plan-workers';

declare var require: any;
declare var $: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-account-plan-2024',
  templateUrl: './plan2024.component.html',
  styleUrl: './plan2024.component.scss'
})
export class Plan2024Component implements OnInit {


  form:any;
  submitted = false;

  plan:any = null;
  updated_plan = false;

  
  hide_contract_form:any = null;

  workers_array:any = [];
  contract:any = null;
  is_live:any = null;
  account_type:any = null;
  loading = false;
  
  workers:any;

  pricing:any;

  sending = false;

  form_min_workers:any = 1;
  form_max_workers:any = 100;
  
  showMinWorkersError = false;
  showMaxWorkersError = false;

  showSalesContact = false;
  salesContactSending = false;
  salesContactSent = false;
  pendingSalesWorkers: number | null = null;

  constructor(public okService: OkAloneService, private transloco: TranslocoService) {

  }

  ngOnInit(): void {

    this.getContract();
  }

  getContract(){
    this.okService.get('billing/contract',{})
    .subscribe((response:any) => {

      let data = response.body;
      //console.log(data);

      if(data['contract']){


        this.contract = data['contract'];
        this.hide_contract_form = this.contract.hide_contract_form;
        this.is_live = this.contract.is_live;
        this.account_type = this.contract.account_type;
        
        
        this.setWorkerArray();

        // A max limit of 1000 for live; non-live can enter 21+ to trigger sales contact.
        if(this.contract.is_live){
          this.form_max_workers = 1000;
          if(this.contract.max_workers < 100){
            this.form_min_workers = this.contract.max_workers;
          }
        } else {
          this.form_max_workers = 1000;
        }


        //console.log(this.contract);
  
        this.workers = +this.contract.max_workers;

        this.plan = {
          "type": "",
          "country": this.contract.country,
          "workers": +this.contract.max_workers,
          "currency": this.contract.currency,
          "essential_fee": +this.contract.per_worker,
          "monitoring": this.contract.live_monitoring==1,
          "monitoring_fee": +this.contract.live_monitoring_fee,
          "automated": this.contract.call_plan==1,
          "automated_fee": +this.contract.call_plan_cost,
          "business": this.contract.business_plan==1,
          "business_fee": +this.contract.business_plan_fee==1,
          "contract_length": this.contract.contract_length > 0 ? this.contract.contract_length : 1,
          "contract_discount": this.contract.contract_discount,
          "volume_discount": this.contract.volume_discount,
        }

        if(this.plan.monitoring){
          this.plan.type = "monitoring";
        }else if(this.plan.automated){
          this.plan.type = "automated";
        }else{
          this.plan.type = "essentials";
        }

        this.plan.essential_total = Utils.dec0(+this.plan.essential_fee * +this.plan.workers);
        this.plan.automated_total = Utils.dec0(+this.plan.automated_fee * +this.plan.workers);
        this.plan.monitoring_total = Utils.dec0(+this.plan.monitoring_fee * +this.plan.workers);
        this.plan.business_total = Utils.dec0(+this.plan.business_fee * +this.plan.workers);

        this.plan.per_worker_total = Utils.dec2(+this.plan.essential_fee + +this.plan.automated_fee + +this.plan.monitoring_fee + +this.plan.business_fee);
        this.plan.total = Utils.dec2(this.plan.per_worker_total * +this.plan.workers);

        //console.log(this.plan);

        this.pricing = {
          workers: this.plan.workers,
          monitoring: this.plan.monitoring,
          automated: this.plan.automated,
          business: this.plan.business,
        };


        this.updated_plan = false;
        

      }


    });

    
  }

  workers_changed(){
    this.showMinWorkersError = false;
    this.showMaxWorkersError = false;
    
    if (this.pricing.workers < this.form_min_workers) {
      this.showMinWorkersError = true;
      this.clearSalesContact();
      return;
    }
    
    if (this.pricing.workers > this.form_max_workers) {
      this.showMaxWorkersError = true;
      this.clearSalesContact();
      return;
    }

    if (requiresSalesContact(+this.pricing.workers)) {
      this.showSalesContact = true;
      this.pendingSalesWorkers = +this.pricing.workers;
      this.salesContactSent = false;
      return;
    }

    this.clearSalesContact();
  }

  submit(){

    this.workers_changed();

    if (requiresSalesContact(+this.pricing.workers)) {
      return;
    }

    this.updatePricing()

  }

  chooseMonitoring(){
    if (requiresSalesContact(+this.pricing.workers)) {
      return;
    }
    this.pricing.monitoring = true;
    this.pricing.automated = true;
    this.updatePricing();
  }

  chooseAutomated(){
    if (requiresSalesContact(+this.pricing.workers)) {
      return;
    }
    this.pricing.monitoring = false;
    this.pricing.automated = true;
    this.updatePricing();
  }

  chooseEssentials(){
    if (requiresSalesContact(+this.pricing.workers)) {
      return;
    }
    this.pricing.monitoring = false;
    this.pricing.automated = false;
    this.updatePricing();
  }

  updatePricing(){

    if (requiresSalesContact(+this.pricing.workers)) {
      return;
    }

    let pricingData = [
      {'currency':'£','essential_fee':4.99,'monitoring_fee':4,'automated_fee':2},
      {'currency':'US$','essential_fee':10,'monitoring_fee':5,'automated_fee':5},
      {'currency':'$','essential_fee':10,'monitoring_fee':5,'automated_fee':5},
    ];

    let new_plan:any =  _.find(pricingData, { 'currency': this.contract.currency });

    if(!new_plan){
      new_plan = {'currency':'US$','essential_fee':10,'monitoring_fee':5,'automated_fee':5};
    }

    const plan = Object.assign({}, this.plan);
    
    new_plan = _.merge(plan,new_plan);
    new_plan = _.merge(new_plan,this.pricing);
    
    new_plan.workers = this.pricing.workers;

    if(new_plan.monitoring){
      new_plan.type = "monitoring";
    }else if(new_plan.automated){
      new_plan.type = "automated";
      new_plan.monitoring_fee = 0;
    }else{
      new_plan.type = "essentials";
      new_plan.automated_fee = 0;
      new_plan.monitoring_fee = 0;
    }

    if (this.is_live) {
      new_plan.essential_fee = this.plan.essential_fee;
      new_plan.monitoring_fee = new_plan.monitoring ? this.plan.monitoring_fee : 0;
      new_plan.automated_fee = new_plan.automated ? this.plan.automated_fee : 0;
      new_plan.business_fee = this.plan.business_fee;
      new_plan.volume_discount = this.plan.volume_discount;
      new_plan.contract_discount = this.plan.contract_discount;
      new_plan.total_discount = +this.plan.volume_discount + +this.plan.contract_discount;
    } else {
      if (!new_plan.monitoring) {
        new_plan.monitoring_fee = 0;
      }
      if (!new_plan.automated) {
        new_plan.automated_fee = 0;
      }
      new_plan.volume_discount = 0;
      new_plan.contract_discount = 0;
      new_plan.total_discount = 0;
    }
    
    new_plan.essential_total = Utils.dec0(+new_plan.essential_fee * +new_plan.workers);
    new_plan.automated_total = Utils.dec0(+new_plan.automated_fee * +new_plan.workers);
    new_plan.monitoring_total = Utils.dec0(+new_plan.monitoring_fee * +new_plan.workers);
    new_plan.business_total = Utils.dec0(+new_plan.business_fee * +new_plan.workers);
    
    new_plan.per_worker_total = Utils.dec2(+new_plan.essential_fee + +new_plan.automated_fee + +new_plan.monitoring_fee + +new_plan.business_fee);
    new_plan.total = Utils.dec2(new_plan.per_worker_total * +new_plan.workers);
    
    new_plan.per_worker = new_plan.essential_fee;

    this.plan = new_plan;

    this.updated_plan = true;

  }


  setWorkerArray(){
  
    let workers_array = [
      {"workers":5,"label":"1 - 5 workers"},
      {"workers":10,"label":"Up to 10 workers"},
      {"workers":15,"label":"Up to 15 workers"},
      {"workers":20,"label":"Up to 20 workers"},
      {"workers":25,"label":"Up to 25 workers"},
      {"workers":30,"label":"Up to 30 workers"},
      {"workers":35,"label":"Up to 35 workers"},
      {"workers":40,"label":"Up to 40 workers"},
      {"workers":45,"label":"Up to 45 workers"},
      {"workers":50,"label":"Up to 50 workers"},
      {"workers":60,"label":"Up to 60 workers"},
      {"workers":70,"label":"Up to 70 workers"},
      {"workers":80,"label":"Up to 80 workers"},
      {"workers":90,"label":"Up to 90 workers"},
      {"workers":100,"label":"Up to 100 workers"},
      // {"workers":110,"label":"Up to 110 workers"},
      // {"workers":120,"label":"Up to 120 workers"},
      // {"workers":130,"label":"Up to 130 workers"},
      // {"workers":140,"label":"Up to 140 workers"},
      // {"workers":150,"label":"Up to 150 workers"},
      // {"workers":160,"label":"Up to 160 workers"},
      // {"workers":170,"label":"Up to 170 workers"},
      // {"workers":180,"label":"Up to 180 workers"},
      // {"workers":190,"label":"Up to 190 workers"},
      // {"workers":200,"label":"Up to 200 workers"},
      // {"workers":250,"label":"Up to 250 workers"},
      // {"workers":300,"label":"Up to 300 workers"},
      // {"workers":350,"label":"Up to 350 workers"},
      // {"workers":400,"label":"Up to 400 workers"},
      // {"workers":450,"label":"Up to 450 workers"},
      // {"workers":500,"label":"Up to 500 workers"}
    ];

    if(this.is_live){
      let max_workers = this.contract.max_workers;
      _.remove(workers_array, function(n:any) {
        return n.workers < max_workers;
      });
    }

    this.workers_array = workers_array;

  }

  savePlan(){
    if (!this.plan || !this.confirmPlanAcceptance()) {
      return;
    }

    if (requiresSalesContact(+this.plan.workers)) {
      return;
    }

    this.sending = true;
    //console.log({plan2024:this.plan});
  
    this.okService.put('billing/contract',{plan2024:this.plan})
    .subscribe((data) => {
  
      this.getContract();
      this.sending = false;
      this.updated_plan = false;
  
    }); 

  }

  confirmPlanAcceptance(): boolean {
    if (!this.plan) {
      return false;
    }

    return showPlanAcceptanceConfirm(getPlanDisplayName(this.plan.type), +this.plan.workers);
  }

  showPlanChangeSection(): boolean {
    return !this.is_live || (this.is_live && this.plan?.type != 'monitoring' && !this.updated_plan);
  }

  showMonitoringPlanOption(): boolean {
    return (this.plan?.country == 'CA' || this.plan?.country == 'US') && this.plan?.type != 'monitoring';
  }

  showAutomatedPlanOption(): boolean {
    return (!this.is_live || !(this.is_live && this.plan?.type == 'monitoring' && !this.updated_plan))
      && this.plan?.type != 'automated';
  }

  showEssentialsPlanOption(): boolean {
    return (!this.is_live || !(this.is_live && (this.plan?.type == 'monitoring' || this.plan?.type == 'automated') && !this.updated_plan))
      && this.plan?.type != 'essentials';
  }

  hasPlanChangeOptions(): boolean {
    if (!this.plan || !this.showPlanChangeSection() || this.showSalesContact) {
      return false;
    }

    return this.showMonitoringPlanOption()
      || this.showAutomatedPlanOption()
      || this.showEssentialsPlanOption();
  }

  clearSalesContact(){
    this.showSalesContact = false;
    this.pendingSalesWorkers = null;
    this.salesContactSent = false;
  }

  confirmSalesContact(){
    this.salesContactSending = true;

    this.okService.post('billing/sales-request', {
      requested_workers: this.pendingSalesWorkers,
      is_live: !!this.is_live,
      account_type: this.account_type,
      plan_type: this.plan?.type,
      current_workers: +this.plan.workers,
    }).subscribe({
      next: () => {
        this.salesContactSending = false;
        this.salesContactSent = true;
      },
      error: () => {
        this.salesContactSending = false;
      },
    });
  }

}
